export const getFileName = size =>
  Math.random()
    .toString(36)
    .substring(size);
